<p>attendance-report works!</p>
